'use client';

import React from 'react';

import {BlockSkeleton} from '@udemy-v2/react-reveal-components';

import styles from './enriched-skills.module.scss';

/**
 * Placeholder for the carousel's pagination controls (chevrons + dots), shown only until
 * the carousel mounts. Reserves the controls' footprint so they don't cause layout shift
 * when they pop in post-hydration.
 */
export const EnrichedSkillsControlsSkeleton: React.FC = () => (
    <div
        className={styles['controls-skeleton']}
        data-purpose="enriched-skills-controls-skeleton"
        aria-busy="true"
        aria-hidden="true"
    >
        <BlockSkeleton className={styles['controls-skeleton-bar']} />
    </div>
);
